import { FilterSelect } from '../../../components/shared/FilterSelect';

interface BudgetToolbarProps {
  fiscalYears: string[];
  selectedFiscalYear: string;
  onFiscalYearChange: (year: string) => void;
  brgs: Array<[number, string]>;
  selectedBrg: number | null;
  onBrgChange: (brgId: number | null) => void;
}

export function BudgetToolbar({
  fiscalYears,
  selectedFiscalYear,
  onFiscalYearChange,
  brgs,
  selectedBrg,
  onBrgChange,
}: BudgetToolbarProps) {
  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: '16px', 
      marginBottom: '18px',
      flexWrap: 'wrap'
    }}>
      <FilterSelect
        label="Fiscal Year:"
        value={selectedFiscalYear}
        onChange={(e) => onFiscalYearChange(e.target.value)}
      >
        {fiscalYears.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </FilterSelect>

      <FilterSelect
        label="BRG:"
        value={selectedBrg || ''}
        onChange={(e) => onBrgChange(e.target.value ? Number(e.target.value) : null)}
      >
        <option value="">All BRGs</option>
        {brgs.map(([id, name]) => (
          <option key={id} value={id}>
            {name}
          </option>
        ))}
      </FilterSelect>
    </div>
  );
}
